import { render } from "./High1.vue?vue&type=template&id=e6171cf4&ts=true"
import script from "./High1.vue?vue&type=script&lang=ts"
export * from "./High1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/High1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6171cf4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6171cf4', __exports__)) {
    api.reload('e6171cf4', __exports__)
  }
  
  module.hot.accept("./High1.vue?vue&type=template&id=e6171cf4&ts=true", () => {
    api.rerender('e6171cf4', render)
  })

}


export default __exports__